import cx from 'classnames';
import ArrowPrev from 'themes/organic/assets/organic_back_arrow.svg';
import ArrowNext from 'themes/organic/assets/organic_next_arrow.svg';
import { Review } from 'themes/organic/components';
import { CtaButton } from 'themes/organic/components/index';
import { ContainedSection } from 'themes/organic/components/sections/ContainedSection';

import { TReview } from 'types/review';

import s from './Reviews.module.css';

interface ReviewsProps {
  currentReviewIndex: number;
  onShowNextReview: () => void;
  onShowPrevReview: () => void;
  reviews: TReview[];
  aboutLink: string;
}

const Reviews = ({
  currentReviewIndex,
  onShowNextReview,
  onShowPrevReview,
  reviews,
  aboutLink,
}: ReviewsProps) => {
  if (reviews.length === 0) {
    return null;
  }

  return (
    <ContainedSection
      id="reviews"
      title="Reviews"
      className={cx(s.root)}
      shapeClassName={s.sectionShapeContainer}
      contentClassName={s.content}
    >
      <Review
        key={reviews[currentReviewIndex].id}
        review={reviews[currentReviewIndex]}
      />
      {reviews.length > 1 && (
        <nav className={s.pagination} aria-label="pagination">
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowPrevReview}
            aria-label="Previous review"
          >
            <ArrowPrev />
          </button>
          <span className={s.paginProgress}>
            {currentReviewIndex + 1} / {reviews.length}
          </span>
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowNextReview}
            aria-label="Next review"
          >
            <ArrowNext />
          </button>
        </nav>
      )}
      <CtaButton
        className={s.cta}
        href={aboutLink}
        style={2}
        title="all reviews"
      >
        all reviews
      </CtaButton>
    </ContainedSection>
  );
};

export { Reviews };
